var render = function (_h,_vm) {var _c=_vm._c;return _c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"my-5 mx-6",attrs:{"src":require("../../assets/logo-saludosConsentidos.png"),"alt":"Logo coaniquem"}})])}
var staticRenderFns = []

export { render, staticRenderFns }